import * as React from "react";
import { makeStyles } from "@material-ui/core";
import { fontFamilyHelvetica, weight } from "@styles/type.styles";
import { greys } from "@styles/color.styles";

export interface ClockwiseHistoryEmptyStateProps {}

const useStyles = makeStyles({
  card: {
    border: `solid 1px ${greys.borderGrey}`,
    borderRadius: 2,
    padding: 7,
  },
  title: {
    fontFamily: fontFamilyHelvetica,
    fontSize: `${13 / 16}rem`,
    lineHeight: 1.5,
    color: greys.slate,
    fontWeight: weight.bold,
  },
  subtitle: {
    fontFamily: fontFamilyHelvetica,
    fontSize: `${12 / 16}rem`,
    lineHeight: 1.5,
    color: greys.slate,
  },
});

export const ClockwiseHistoryEmptyState = ({}: ClockwiseHistoryEmptyStateProps) => {
  const classes = useStyles();

  return (
    <div className={classes.card}>
      <p className={classes.title}>
        History isn’t available for this event because it has never been managed by Clockwise
      </p>
      <p className={classes.subtitle}>
        When an event is made flexible, event modifications will display here.
      </p>
    </div>
  );
};
